<template>
  <div class="wrapper">
    <div :class="`${disabled ? 'member-icon-disabled' : 'member-icon'}`">
      <svg>
        <use xlink:href="/assets/public/images/icons.svg#member" />
      </svg>
    </div>
    <div>
      <h3 class="h6 relationship">
        {{ showLastName ? `${firstName} ${lastName}` : `${firstName}` }}
      </h3>
      <p class="relationship">{{ sentenceCase(relationship) }}</p>
    </div>
  </div>
</template>

<script>
import { sentenceCase } from '@/utils/DisplayUtils';

export default {
  name: 'MemberTag',

  props: {
    firstName: {
      type: String,
      required: true,
    },

    lastName: {
      type: String,
      required: true,
    },

    relationship: {
      type: String,
      requried: true,
    },

    showLastName: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    sentenceCase,
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  gap: 1.5rem;
  margin: auto 0;

  .member-icon {
    box-sizing: border-box;
    height: 45px;
    width: 45px;
    padding: 12.5px;
    background-color: $PRIMARY_GREEN_TINT;
    align-self: center;

    svg {
      width: 20px;
      height: 20px;
      color: $PRIMARY_GREEN;
    }
  }

  .member-icon-disabled {
    box-sizing: border-box;
    height: 45px;
    width: 45px;
    padding: 12.5px;
    background-color: $GREY_300;

    svg {
      width: 20px;
      height: 20px;
      color: $DISABLED;
    }
  }

  .relationship {
    margin: 0;
  }
}
</style>
